var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPdf = function SvgIcPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 18,
    viewBox: "0 0 36 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    fill: "#DD4A38",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9.71,12 L10.88,12 L10.88,9.51 L12.64,9.51 C14.03,9.51 14.82,8.55 14.82,7.42 C14.82,6.29 14.04,5.33 12.64,5.33 L9.71,5.33 L9.71,12 Z M13.62,7.42 C13.62,8.06 13.14,8.48 12.48,8.48 L10.88,8.48 L10.88,6.36 L12.48,6.36 C13.14,6.36 13.62,6.78 13.62,7.42 Z M15.79,12 L18.27,12 C20.35,12 21.76,10.63 21.76,8.67 C21.76,6.71 20.35,5.33 18.27,5.33 L15.79,5.33 L15.79,12 Z M16.96,10.97 L16.96,6.36 L18.27,6.36 C19.76,6.36 20.56,7.38 20.56,8.67 C20.56,9.93 19.72,10.97 18.27,10.97 L16.96,10.97 Z M22.89,12 L22.89,5.33 L27.46,5.33 L27.46,6.36 L24.06,6.36 L24.06,8.09 L27.39,8.09 L27.39,9.12 L24.06,9.12 L24.06,12 L22.89,12 Z"
  }))));
};
export default SvgIcPdf;